import { useEffect, useState } from "react";
import { api } from "../../lib/api";
import { MapPin } from "lucide-react";

const FALLBACK_TITLE = "Junto al R2, 9 arcos";

export default function Ubicacion() {
  const [data, setData] = useState(null);
  useEffect(() => {
    api.get("/content/ubicacion").then((r) => setData(r.data.data || {})).catch(() => setData({}));
  }, []);
  if (!data) return <div className="p-8 text-muted-foreground">Cargando…</div>;

  const title = String(data.title ?? "").trim() || FALLBACK_TITLE;

  return (
    <div className="space-y-6 animate-in fade-in duration-500" data-testid="ubicacion-page">
      <header className="py-4">
        <div className="text-xs uppercase tracking-[0.25em] text-primary font-bold">Ubicación</div>
        <h1 className="font-display font-black text-4xl sm:text-5xl mt-1">{title}</h1>
      </header>

      <div className="bg-white rounded-2xl border border-border p-6 space-y-4">
        <div className="flex items-start gap-3">
          <div className="h-10 w-10 rounded-full bg-primary/10 text-primary grid place-items-center shrink-0">
            <MapPin size={20} />
          </div>
          <div className="whitespace-pre-line text-base leading-relaxed" data-testid="ubicacion-body">{data.body}</div>
        </div>
      </div>

      {data.map_embed && (
        <div className="rounded-2xl overflow-hidden border border-border bg-white" data-testid="ubicacion-map">
          <iframe
            src={data.map_embed}
            width="100%"
            height="360"
            style={{ border: 0 }}
            allowFullScreen=""
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
            title="Mapa Casa del Pueblo"
          />
        </div>
      )}

      <a
        href="https://www.google.com/maps/search/?api=1&query=Recinto+Ferial+Albacete"
        target="_blank"
        rel="noreferrer"
        className="inline-flex items-center gap-2 bg-primary text-primary-foreground px-5 py-3 rounded-full font-bold hover:brightness-110 transition"
        data-testid="ubicacion-maps-cta"
      >
        <MapPin size={16} /> Abrir en Google Maps
      </a>
    </div>
  );
}
